export default __webpack_public_path__ + "static/media/closeMessagesIcon.9e9b96f1.svg";